import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { uerpPlatformApps } from "../uerpModulesData";

const iconMap: Record<string, React.ReactNode> = {
  student: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 3L2 8l10 5 10-5-10-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M6 11v5c0 2 2.5 4 6 4s6-2 6-4v-5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  faculty: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="1.5" />
      <path d="M3 19c0-3 2.5-5 6-5s6 2 6 5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M17 11h4M19 9v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  admin: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="3" width="7" height="9" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="14" y="3" width="7" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="14" y="12" width="7" height="9" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="3" y="16" width="7" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  alumni: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="8" cy="8" r="3" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="17" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M2 19c0-3 2.5-5 6-5s6 2 6 5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M17 14c2.5 0 4 1.5 4 5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
};

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

const UerpWhatWeProvideSection: React.FC = () => (
  <section className="wdev-why" aria-labelledby="uerp-provide-title">
    <div className="container">
      <AnimatedSection className="wdev-section-head wdev-section-head--center">
        <h2 id="uerp-provide-title" className="wdev-section-head__title">
          What We Provide
        </h2>
        <p className="uerp-section-lead">
          Dedicated portals for every stakeholder in your institution — students, faculty,
          administrators, parents, and alumni.
        </p>
      </AnimatedSection>

      <div className="wdev-why__grid uerp-platform-grid">
        {uerpPlatformApps.map((app, index) => (
          <motion.article
            key={app.title}
            className="wdev-why-card uerp-platform-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-40px" }}
            custom={index}
            variants={cardVariants}
            whileHover={{ y: -6, transition: { duration: 0.25 } }}
          >
            <div className="wdev-why-card__icon">{iconMap[app.icon]}</div>
            <h3 className="uerp-platform-card__title">{app.title}</h3>
            <p className="uerp-platform-card__desc">{app.description}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default UerpWhatWeProvideSection;
